import {
  Entity,
  PrimaryKey,
  Property,
  Unique,
  OneToMany,
  Collection,
} from '@mikro-orm/core';
import { UserCategory } from './user-category.entity';

@Entity({ tableName: 'categories' })
export class Category {
  @PrimaryKey()
  id!: number;

  @Property({ type: 'varchar', length: 150 })
  @Unique()
  name!: string;

  @Property({ type: 'varchar', length: 150, nullable: true })
  slug?: string | null;

  @OneToMany(() => UserCategory, (uc) => uc.category)
  userCategories = new Collection<UserCategory>(this);

  @Property({ type: 'datetime' })
  created_at: Date = new Date();

  @Property({ type: 'datetime', onUpdate: () => new Date() })
  updated_at?: Date = new Date();

  @Property({ type: 'datetime', nullable: true })
  deleted_at?: Date | null = null;
}
